import { render, staticRenderFns } from "./course_join.vue?vue&type=template&id=0ae12436&scoped=true&"
import script from "./course_join.vue?vue&type=script&lang=js&"
export * from "./course_join.vue?vue&type=script&lang=js&"
import style0 from "./course_join.vue?vue&type=style&index=0&id=0ae12436&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae12436",
  null
  
)

export default component.exports